<template>
  <div class="multiSelect">
    <div type="text" class="ginput" @click="open">
      <template v-if="disValue">{{disValue}}</template>
      <span v-else class="ph">{{placeholder}}</span>
    </div>
    <i class="iconfont icon-xia" @click="open"></i>
    <mt-popup v-model="show" position="right" class="setroom" :modal="false">
      <transition name="fade">
        <div class="area_ctrl">
          <div class="area_btn_box">
            <div class="area_btn larea_cancel" @click="close">{{$t('cancel')}}</div>
            <div class="area_btn larea_cancel" @click="select(false)">{{$t('empty')}}</div>
            <div class="area_btn larea_cancel" @click="select(true)">{{$t('selectAll')}}</div>
            <div class="area_btn larea_finish" @click="finish">{{$t('determine')}}</div>
          </div>
          <div class="area_roll">
            <div class="gear area_province">
              <div class="tooth" v-for="(item,index) in disData" :key="index" :class="{ck:item.checked}"
                   @click="setCheck(item,$event)">{{showCode1 ? item.code1 : item.code}} -- {{item.name}}
                <i class="iconfont icon-right" v-if="item.checked"></i>
              </div>
            </div>
            <div class="area_grid">
            </div>
          </div>
        </div>
      </transition>
    </mt-popup>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        show: false,
        disValue: "",
        value: "",
        data: [],
        disData: []
      };
    },
    props: {
      placeholder: {
        type: String
      },
      maxNumber: {
        type: Number,
        default: null
      },
      complexValue: {
        type: Boolean,
        default: false
      },
      showCode1: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
    },
    methods: {
      setData(datas, dv) {
        this.data = datas;
        this.show = false;
        this.setInit(dv);
      },
      setCheck(item, e) {
        e.stopPropagation();
        console.log(this.disData)
        if (item.checked) {
          this.$set(item, "checked", !item.checked);
        } else {
          if (this.maxNumber > 0) {
            let disData = this.disData || []
            let temp = 0
            disData.map((item, index) => {
              if (item.checked) {
                temp += 1
              }
            })
            if (temp < this.maxNumber) {
              this.$set(item, "checked", !item.checked);
            } else {
              this.msg2('最多只能选择' + this.maxNumber + '项')
            }
            console.log('一共悬了', temp)
          } else {
            this.$set(item, "checked", !item.checked);
            console.log(item.checked);
          }
        }
      },
      setInit(dv) {
        this.value = dv == null ? "" : dv;
        this.disValue = "";
        this.disData = [];
        var sp = this.value == "" ? [] : this.value.split(',');
        for (var i = 0; i < this.data.length; i++) {
          var item = this.data[i];
          var find = false;
          for (var n = 0; n < sp.length; n++) {
            if (item.code == sp[n]) {
              find = true;
              if (this.disValue == "") {
                this.disValue = item.name;
              } else {
                this.disValue += "," + item.name;
              }
              break;
            }
          }
          this.disData.push({'code': item.code, 'code1': item.code1 || item.code, 'name': item.name, 'checked': find});
        }

      },
      setDefault(v) {
        this.setInit(v);
      },
      open() {
        this.show = !this.show;
      },
      select(b) {
        for (var i = 0; i < this.disData.length; i++) {
          this.disData[i].checked = b;
        }
      },
      close() {
        this.show = false;
      },
      finish() {
        this.disValue = "";
        this.value = "";
        for (var i = 0; i < this.disData.length; i++) {
          var item = this.disData[i];
          if (item.checked) {
            if (this.disValue == "") {
              this.disValue = item.name;
              this.value = item.code;
            } else {
              this.disValue += "," + item.name;
              this.value += "," + item.code;
            }
          }
        }
        this.show = false;
        if (this.complexValue){
          let arr =  this.disData.filter((item, index) => {
            return item.checked
          })
          this.$emit('finish', arr)
        } else {
          this.$emit('finish', this.value)
        }
      },
      getValue() {
        return this.value;
      }
    },
    filters: {},
    watch: {},
    components: {}
  };
</script>

<style lang="less">
  .multiSelect {
    height: 0.8rem;
    line-height: 0.8rem;

    .mint-popup{
      position: fixed;
    }

    .ginput {
      width: 100%;
      height: 100%;
      padding-right: 0.5rem;
      overflow: hidden;
      box-sizing: border-box;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .icon-xia {
      position: absolute;
      right: 0.08rem;
      top: 0px;
    }

    .ph {
      color: #ccc;
    }

    .setroom {
      z-index: 1001 !important;
      width: 100%;
      height: 100%;
      background-color: #fff;

      .ck {
        background: #a8c6ee;
      }

      .gearArea {
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 10px;
        background-color: rgba(0, 0, 0, 0.2);
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9900;
        overflow: hidden;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both
      }

      .area_ctrl {
        font-size: 12px;
        vertical-align: middle;
        background-color: #d5d8df;
        color: #000;
        margin: 0;
        height: 100%;
        width: 100%;
        z-index: 9901;
        overflow: hidden;
        /* -webkit-transform: translate3d(0, 100%, 0);
transform: translate3d(0, 100%, 0) */
      }

      .fade-enter-active,
      .fade-leave-active {
        transition: .3s;
      }

      .fade-enter,
      .fade-leave-to {
        -webkit-transform: translate3d(0, 100%, 0);
        transform: translate3d(0, 100%, 0)
      }

      .area_roll {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        width: 100%;
        height: auto;
        overflow: hidden;
        background-color: transparent;
        font-size: 1.6em;

        flex: 1
      }

      .area_roll .gear {
        width: 100%;
        float: left;
        height: ~"calc(100vh - 2.5em)";
        overflow-y: scroll;
      }

      .area_btn {
        color: #0575f2;
        font-size: 1.4em;
        line-height: 1em;
        text-align: center;
        padding: .8em 1em
      }

      .area_btn_box:before,
      .area_btn_box:after {
        content: '';
        position: absolute;
        height: 1px;
        width: 100%;
        display: block;
        background-color: #96979b;
        z-index: 15;
        -webkit-transform: scaleY(0.33);
        transform: scaleY(0.33)
      }

      .area_btn_box {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: stretch;
        -webkit-align-items: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        background-color: #f1f2f4;
        position: relative
      }

      .area_btn_box:before {
        left: 0;
        top: 0;
        -webkit-transform-origin: 50% 20%;
        transform-origin: 50% 20%
      }

      .area_btn_box:after {
        left: 0;
        bottom: 0;
        -webkit-transform-origin: 50% 70%;
        transform-origin: 50% 70%
      }

      .tooth {
        height: 2em;
        line-height: 2em;
        text-align: center;
        display: flex;
        position: relative;
        flex-direction: column;
        overflow: hidden
      }

    }
  }
</style>



// WEBPACK FOOTER //
// multiSelect.vue?ad1101d8